import { render, staticRenderFns } from "./widgetBody.vue?vue&type=template&id=2427bbc8&scoped=true"
import script from "./widgetBody.vue?vue&type=script&lang=js"
export * from "./widgetBody.vue?vue&type=script&lang=js"
import style0 from "./widgetBody.vue?vue&type=style&index=0&id=2427bbc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427bbc8",
  null
  
)

export default component.exports